// extracted by mini-css-extract-plugin
module.exports = {"modal_div":"ModalWrapper_modal_div__2Fx_k","close":"ModalWrapper_close__3aBdO"};